/* src/app/app.topbar.component.scss */
.topbar ul.topbar-items {
  position: absolute;
  right: 10px;
}
.topbar ul.topbar-items li.profile-item {
  cursor: pointer;
  margin-top: 0.2rem;
  margin-left: 3rem;
}
.topbar ul.topbar-items li.profile-item > a > span {
  font-size: 1.25em;
  display: table;
}
.topbar ul.topbar-items li .p-menu-separator {
  color: white !important;
  background-color: white !important;
  display: inline-block;
  vertical-align: middle;
  height: 1.5rem;
  border: 1px solid white;
}
.topbar ul.topbar-items li > ul.layout-menu li {
  display: flex;
}
.topbar ul.topbar-items li > ul.layout-menu li.p-menu-separator {
  color: black !important;
  background-color: black !important;
  display: inline-block;
  vertical-align: middle;
  height: 1px;
  width: 100%;
  border: 1px solid black;
}
.topbar ul.topbar-items li > ul.layout-menu li.selected {
  background-color: rgba(0, 0, 88, 0.2);
}
.topbar ul.topbar-items li > ul.layout-menu li a {
  display: inline-flex;
}
.topbar ul.topbar-items li > ul.layout-menu li a > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.topbar .company-title > a {
  color: white;
  text-decoration: none;
  display: inline-flex;
}
.topbar .company-title > a h2 {
  color: white;
  padding-right: 1em;
}
.topbar .company-title > a i {
  color: white;
  font-size: 24px;
}
:host ::ng-deep .p-dialog-content {
  background-color: rgba(30, 60, 114, 0.2);
  backdrop-filter: blur(5px);
}
:host ::ng-deep .layout-topbar-search {
  position: relative;
  display: flex;
  align-items: center;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete {
  position: relative;
  width: 100%;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-input {
  border: 0px;
  background-color: transparent;
  padding-right: 2.5rem !important;
  min-width: 25vh;
  max-width: 35vh;
  overflow: hidden;
  color: var(--topbar-item-text-color) !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-input::placeholder {
  color: var(--topbar-item-text-color) !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: var(--topbar-item-text-color) !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer !important;
  font-size: 1rem !important;
  z-index: 12 !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
  min-width: 1.5rem !important;
  min-height: 1.5rem !important;
  max-width: 1.5rem !important;
  max-height: 1.5rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  line-height: 1 !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon:hover,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon:focus,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear:focus {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon .p-icon,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon i,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear .p-icon,
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear i {
  color: var(--topbar-item-text-color) !important;
  font-size: 0.875rem !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-dropdown {
  display: none !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-panel {
  background: var(--surface-overlay) !important;
  border: 1px solid var(--surface-border) !important;
  border-radius: var(--border-radius) !important;
  box-shadow: var(--shadow-overlay) !important;
  z-index: 9999 !important;
  max-height: 200px !important;
  overflow-y: auto !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  padding: 0.75rem 1rem !important;
  border: none !important;
  color: var(--text-color) !important;
  background: transparent !important;
  transition: background-color var(--transition-duration) !important;
  border-radius: 0 !important;
  cursor: pointer !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {
  background: var(--surface-hover) !important;
}
:host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {
  background: var(--primary-color) !important;
  color: var(--primary-color-text) !important;
}
:host ::ng-deep .layout-topbar-search .search-icon {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: var(--topbar-item-text-color) !important;
  font-size: 1rem !important;
  z-index: 11 !important;
  cursor: pointer !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
}
:host ::ng-deep .layout-topbar-search .search-icon:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
:host ::ng-deep .layout-topbar-search .search-icon.hidden {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
@media screen and (max-width: 991px) {
  :host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-input {
    min-width: 15vh;
    max-width: 20vh;
  }
}
@media screen and (max-width: 768px) {
  :host ::ng-deep .layout-topbar-search .p-autocomplete .p-autocomplete-input {
    min-width: 10vh;
    max-width: 15vh;
  }
}
@media screen and (max-width: 991px) {
  :host ::ng-deep .p-autocomplete-input.p-inputtext.p-component {
    min-width: 15vh;
    max-width: 20vh;
    text-indent: 0.5em;
  }
}
@media screen and (max-width: 768px) {
  :host ::ng-deep .p-autocomplete-input.p-inputtext.p-component {
    min-width: 10vh;
    max-width: 15vh;
    text-indent: 0.25em;
  }
}
/*# sourceMappingURL=app.topbar.component.css.map */
